// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "iframe[data-v-2383f8d8]{border:none;height:100%;width:100%}", ""]);
// Exports
module.exports = exports;
